import { SubmissionMenuKey } from '@framework/frontoffice-submission/src/submission/hooks/useSubmissionMenuItems';
import { useHistory } from '@framework/ui';
import { useMemo } from 'react';

/**
 * Hook che, partendo dalla location corrente, restituisce la chiave del menu
 * selezionata attualmente.
 * /invia -> Report
 * /pagamenti -> Payment
 * /moduli/:moduleId -> moduleId
 * / -> Guide
 */
export function useSubmissionMenuSelectedKey() {
  const history = useHistory();

  const menuSelectedKey = useMemo(() => {
    const pathname = history.location.pathname as string;
    if (pathname.endsWith('invia')) {
      return SubmissionMenuKey.Report;
    }
    if (pathname.endsWith('pagamenti') || pathname.endsWith('payments')) {
      return SubmissionMenuKey.Payment;
    }
    if (!pathname.includes('moduli') && !pathname.includes('modules')) {
      return SubmissionMenuKey.Guide;
    }
    // /moduli/:moduleId
    const moduleId = pathname.split('/').pop();

    return moduleId;
  }, [history.location.pathname]);

  return menuSelectedKey;
}

export function isModuleSelected(menuSelectedKey: string | null | undefined) {
  if (!menuSelectedKey) return false;
  return ![
    SubmissionMenuKey.Guide,
    SubmissionMenuKey.Payment,
    SubmissionMenuKey.Report,
  ].includes(menuSelectedKey as any);
}
